export default __webpack_public_path__ + "static/Patient-Centric-Care-e6fa9a9dbc1928f48b5e728536e6bd85.webp";